module.exports = __webpack_public_path__ + "static/img/trainlogo.3cd4974.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/introduce/images/trainlogo.png
// module id = 6NcS
// module chunks = 21